import axios from "axios";
import Api from "../Api";

const Service = {
  async get() {
    try {
      const data = {
        "PAGE": 0,
        "LIMIT": 10,
        "FIELDS": [
          "_id",
          "PIN_CODE",
          "EXPIRE_DATE",
          "MAX_COUNT",
          "ACTIVE",
          "INVOICE_NO",
          "PERMISSION"
        ]
      }
      const response = await axios.post(`${Api}/api/GET_ALL_ACCOUNTS`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );
      if (response.status === 200) {

        return { success: true, data: response.data };
      } else if (response.status === 403) {
        localStorage.clear();
        window.location.reload();
      }
    } catch (error) {
      return { success: false, error };
    }
  },
  async getByPinCode(data) {
    try {
      const response = await axios.post(`${Api}/api/GET_ACCOUNT_INFO_BY_PIN_CODE_OR_INVOICE_NO`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );
      if (response.status === 200) {

        return { success: true, data: response.data };
      } else if (response.status === 403) {
        localStorage.clear();
        window.location.reload();
      }
    } catch (error) {
      return { success: false, error };
    }
  },

  async post(data, link) {
    try {
      const response = await axios.post(
        `${Api}/api/${link}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );

      if (response.status === 200) {
        return { success: true, data: response.data };
      }
    } catch (error) {

      console.log(error)
      return { success: false, error };
    }
  },


  async delete(id) {
    try {
      const data = {
        "_id": id
      }
      const response = await axios.post(
        `${Api}/api/updates/DELETES_UPDATE`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
    } catch (error) {
      return { success: false, error };
    }
  },
};

export default Service;
